const getDoaminName = () => {
    if (typeof window === "undefined") {
        console.warn(
            "getApiEndPoints called on the server. Returning default values."
        );
        return ''
    }

    let windowUrl = window.location.href;
    if (windowUrl.includes("://")) {
        windowUrl = windowUrl.split("://")[1];
    }
    const domainFirstname = windowUrl.split(".")[0]?.split("/")[0];
    return domainFirstname

}

export default getDoaminName







